(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Tooolbar", [], factory);
	else if(typeof exports === 'object')
		exports["Tooolbar"] = factory();
	else
		root["Tooolbar"] = factory();
})(this, function() {
return 